export enum OnlineStatus {
    Online = 'online',
    ManualOffline = 'manualOffline',
    NoNetwork = 'noNetwork',
    InternalFail = 'internalFail',
    ExternalFail = 'externalFail',
    HasOfflineRegs = 'hasOfflineRegs'
}
